@if (showField$ | async) {
  <mat-form-field [floatLabel]="field.floatLabel || 'auto'">
    @if (field.prefixIcon) {
      <div matPrefix>
        <mat-icon>{{field.prefixIcon}}</mat-icon>&nbsp;
      </div>
    }
    @if (field.label) {
      <mat-label>{{ field.label | translate }}</mat-label>
    }
    <input matInput
      [required]="!!field.validators?.required"
      [attr.type]="field.type"
      [attr.name]="field.name"
      [attr.min]="field.attrs.min"
      [attr.max]="field.attrs.max"
      [ngStyle]="field.attrs.style"
      [readonly]="field.attrs.readonly"
      [attr.autocomplete]="field.attrs.autocomplete || field.type === 'password' ? 'off' : 'on'"
      [placeholder]="field.placeholder | translate"
      [formControl]="$any(field.control)">
    @if (field.actionButton) {
      <button matSuffix mat-icon-button
        [matTooltip]="field.actionButton.tooltip" aria-label="action"
        (click)="actionButtonClicked.emit(field)"
        >
        <mat-icon>{{ field.actionButton.icon }}</mat-icon>
      </button>
    }
    @if (hasDanger()) {
      <mat-hint [ngStyle]="{'color': 'red'}" align="start">{{errorText()}}</mat-hint>
    }
    @if (field.help && !hasDanger()) {
      <mat-hint align="start">{{field.help | translate}}</mat-hint>
    }
  </mat-form-field>
}
